// TODO: 6월 21일 라이브버전 주석처리
import { useEffect } from 'react'
import { useSnackbar } from 'notistack'
import { Route, Routes, useLocation } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import styled from 'styled-components'

import { useSocialLogin } from '~/features/auth/queries/useAuth'
import { type LoginAuthProps, setAuthInfo } from '~/features/auth/utils/auth'
import PaymentModal from '~/features/payment/components/PaymentModal'
import PasswordChangeCompletedPage from '~/pages/auth/PasswordChangeCompletedPage'
import SignUpCompletedPage from '~/pages/auth/SignUpCompletedPage'
import TermsOfPolicyPage from '~/pages/auth/TermsOfPolicyPage'
import CircleApplyAddInfoPage from '~/pages/circle-participation/CircleApplyAddInfoPage'
import CircleApplyDetailPage from '~/pages/circle-participation/CircleApplyDetailPage'
import CircleApplyListPage from '~/pages/circle-participation/CircleApplyListPage'
import CircleApplyModifyPage from '~/pages/circle-participation/CircleApplyModifyPage'
import CircleApplyPage from '~/pages/circle-participation/CircleApplyPage'
import CircleInfoDetailPage from '~/pages/circle-participation/CircleInfoDetailPage'
import CircleInfoPage from '~/pages/circle-participation/CircleInfoPage'
import CorporateInfoPage from '~/pages/corporate-participation/CorporateInfoPage'
import EventInfoPage from '~/pages/event-info/EventInfoPage'
import GeneralInfoPage from '~/pages/general-participation/GeneralInfoPage'
import HomePage from '~/pages/home/HomePage'
import InquiryCreatePage from '~/pages/inquiry/InquiryCreatePage'
import InquiryDetailPage from '~/pages/inquiry/InquiryDetailPage'
import InquiryPage from '~/pages/inquiry/InquiryPage'
import InquiryUpdatePage from '~/pages/inquiry/InquiryUpdatePage'
import MyPage from '~/pages/mypage/MyPage'
import NoticeDetailPage from '~/pages/notice/NoticeDetailPage'
import NoticePage from '~/pages/notice/NoticePage'
import FailPage from '~/pages/payment/FailPage'
import SuccessPage from '~/pages/payment/SuccessPage'
import RatingRulePage from '~/pages/rating-rule/RatingRulePage'
import SpecialPerformancePage from '~/pages/special-performance/SpecialPerformancePage'
import TestPage from '~/pages/test'
import TicketPage from '~/pages/ticket/TicketPage'
import CircleParticipation from '~/shared/assets/background/circle-participation.png'
import Footer from '~/shared/components/footer/Footer'
import Header from '~/shared/components/header/Header'
import Modal from '~/shared/components/modals/Modal'
import NestedModal from '~/shared/components/modals/NestedModal'
import NotFound from '~/shared/components/NotFound'
import ScrollToTopButton from '~/shared/components/scrollToTop/ScrollToTop'
import Seo from '~/shared/components/seo/Seo'
import useScrollToTop from '~/shared/hooks/useScrollToTop'
import { JOIN_TYPE } from '~/shared/http-client/exceptions/type'
import {
  isModalOpenState,
  isNestedModalOpenState,
  isPaymentModalOpenState,
} from '~/shared/states'
import theme from '~/shared/styles/theme'
import AuthRouter from '~/shared/utils/AuthRouter'
import RefreshRouter from '~/shared/utils/RefreshRouter'

function App() {
  useScrollToTop()
  const location = useLocation()
  const { enqueueSnackbar } = useSnackbar()

  // console.log(' ENV : ', import.meta.env.MODE)

  const [isModalOpen] = useRecoilState(isModalOpenState)
  const [isNestedModalOpen] = useRecoilState(isNestedModalOpenState)
  const [isPaymentModalOpen] = useRecoilState(isPaymentModalOpenState)

  const { mutate: socialLogin } = useSocialLogin()
  const loginType = localStorage.getItem('starlike-login-type')
  const params = new URLSearchParams(location.search)
  const code = params.get('code')

  // 네이버 로그인 코드
  useEffect(() => {
    if (code && !loginType) {
      socialLogin(
        { code: code, type: JOIN_TYPE.NAVER },
        {
          onSuccess: (res) => {
            if (res.errorCode < 0) {
              enqueueSnackbar(res.errorMsg, {
                variant: 'error',
              })
            } else {
              if (res.data) {
                setAuthInfo({ data: res.data } as LoginAuthProps)
              }

              enqueueSnackbar('로그인이 완료되었습니다.', {
                variant: 'success',
              })
              localStorage.setItem('starlike-login-type', 'naver')
            }
          },
          onError: (error) => {
            enqueueSnackbar(error.message, { variant: 'error' })
          },
        },
      )
    }
  }, [location, loginType])

  return (
    <Wrapper
      $circleparticipation={CircleParticipation}
      $pathname={location.pathname}
    >
      <Seo />
      {isModalOpen.isOpen ? <Modal /> : null}
      {isNestedModalOpen.isOpen ? <NestedModal /> : null}
      {isPaymentModalOpen.isOpen ? <PaymentModal /> : null}
      <Header />
      <Main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/event-info/introduction" element={<EventInfoPage />} />
          <Route path="/event-info/timetable" element={<EventInfoPage />} />
          <Route path="/event-info/layout" element={<EventInfoPage />} />
          <Route path="/event-info/circle-list" element={<EventInfoPage />} />
          <Route path="/terms" element={<TermsOfPolicyPage />} />
          <Route
            path="/auth/sign-up-completed"
            element={<SignUpCompletedPage />}
          />
          <Route
            path="/auth/password-change-completed"
            element={<PasswordChangeCompletedPage />}
          />
          <Route
            path="/sif-rainbowstage1"
            element={<SpecialPerformancePage />}
          />
          <Route
            path="/general-participation/info"
            element={<GeneralInfoPage />}
          />
          <Route
            path="/general-participation/cosplayer"
            element={<GeneralInfoPage />}
          />
          <Route
            path="/general-participation/ticket"
            element={<TicketPage />}
          />
          <Route
            path="/circle-participation/info"
            element={<CircleInfoPage />}
          />
          <Route
            path="/circle-participation/info/:circleId"
            element={<CircleInfoDetailPage />}
          />
          <Route
            path="/circle-participation/apply"
            element={
              <AuthRouter>
                <RefreshRouter>
                  <CircleApplyPage />
                </RefreshRouter>
              </AuthRouter>
            }
          />
          <Route
            path="/circle-participation/apply-list"
            element={
              <AuthRouter>
                <CircleApplyListPage />
              </AuthRouter>
            }
          />
          <Route
            path="/circle-participation/apply-list/:applicationId"
            element={
              <AuthRouter>
                <CircleApplyDetailPage />
              </AuthRouter>
            }
          />
          <Route
            path="/circle-participation/edit/:applicationId"
            element={
              <AuthRouter>
                <CircleApplyModifyPage />
              </AuthRouter>
            }
          />
          <Route
            path="/circle-participation/add/:applicationId"
            element={
              <AuthRouter>
                <CircleApplyAddInfoPage />
              </AuthRouter>
            }
          />
          <Route path="/notice" element={<NoticePage />} />
          <Route path="/notice/:id" element={<NoticeDetailPage />} />
          <Route
            path="/customer-service/inquiry"
            element={
              <AuthRouter>
                <InquiryPage />
              </AuthRouter>
            }
          />
          <Route
            path="/customer-service/inquiry/:id"
            element={
              <AuthRouter>
                <InquiryDetailPage />
              </AuthRouter>
            }
          />
          <Route
            path="/customer-service/inquiry/create"
            element={
              <AuthRouter>
                <InquiryCreatePage />
              </AuthRouter>
            }
          />
          <Route
            path="/customer-service/inquiry/update"
            element={
              <AuthRouter>
                <InquiryUpdatePage />
              </AuthRouter>
            }
          />
          <Route path="/customer-service/faq" element={<InquiryPage />} />
          <Route
            path="/corporate-participation/info"
            element={<CorporateInfoPage />}
          />
          <Route
            path="/mypage"
            element={
              <AuthRouter>
                <MyPage />
              </AuthRouter>
            }
          />
          <Route path="/test" element={<TestPage />} />
          <Route
            path="/success"
            element={
              <AuthRouter>
                <SuccessPage />
              </AuthRouter>
            }
          />
          <Route
            path="/fail"
            element={
              <AuthRouter>
                <FailPage />
              </AuthRouter>
            }
          />
          <Route path="/rating-rule" element={<RatingRulePage />} />
          <Route path="/*" element={<NotFound />} />
        </Routes>
      </Main>
      <ScrollToTopButton />
      <Footer />
    </Wrapper>
  )
}

export default App

const Main = styled.div`
  overflow: hidden;
  flex-grow: 1;
  height: auto;
  height: fit-content;
`

const Wrapper = styled.div<{
  $circleparticipation: string
  $pathname: string
}>`
  position: relative;

  display: flex;
  flex-direction: column;

  box-sizing: border-box;
  width: 100vw;
  min-height: 100vh;

  background-repeat: repeat repeat;
  ${(props) =>
    (props.$pathname.indexOf('/circle-participation/apply') !== -1 ||
      props.$pathname.indexOf('/mypage') !== -1) &&
    `background-image: url(${props.$circleparticipation});`};
  background-size: 100vw auto;

  @media ${theme.device.large} {
    width: 100%;
  }

  @media ${theme.device.medium} {
    width: 100%;
    height: auto;
  }
`
